import dayjs from 'dayjs';

export const toDate = (date: any): Date | undefined => {
  return date instanceof Date
    ? date
    : dayjs(date).isValid()
    ? dayjs(date).toDate()
    : undefined;
};
